import React, { useEffect, useRef } from "react";
import { ScrollView, View } from "react-native";
import { Tab } from "../ui/tab";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "../utils/convex-api";
import { useQuery } from "@tanstack/react-query";
import { Button } from "../ui/button";
import PlusIcon from "@/assets/svgs/plus-icon";

function ChildrenSelectionList({
  selectedChildId,
  setSelectedChildId,
  createMode,
  setCreateMode,
}: {
  selectedChildId: string | null;
  setSelectedChildId: (childId: string) => void;
  createMode: boolean;
  setCreateMode: (createMode: boolean) => void;
}) {
  const { data: children = [], isSuccess } = useQuery(
    convexQuery(api.parent.manageChildren.queries.getAllChildren, {})
  );
  const [firstChild] = children;
  const firstChildId = firstChild?._id;
  const childrenCount = children.length;
  const scrollViewRef = useRef<ScrollView>(null);

  useEffect(() => {
    if (firstChildId && !selectedChildId) {
      setSelectedChildId(firstChildId);
    }
  }, [firstChildId, selectedChildId, setSelectedChildId]);

  useEffect(() => {
    if (isSuccess && childrenCount === 0) {
      setCreateMode(true);
    }
  }, [isSuccess, childrenCount, setCreateMode]);

  return (
    <View className="flex-row items-center">
      <ScrollView horizontal ref={scrollViewRef} showsHorizontalScrollIndicator={false}>
        {children.map((child) => (
          <Tab
            size="md"
            key={child._id}
            intent={
              selectedChildId === child._id && !createMode
                ? "active"
                : "inActive"
            }
            onPress={() => {
              setSelectedChildId(child._id);
              setCreateMode(false);
            }}
            className="border-none"
          >
            <Tab.Avatar size="sm">
              <Tab.Avatar.Content size="sm" label={child.name} labelSize="sm" />
            </Tab.Avatar>
            <Tab.Text size="md">{child.name}</Tab.Text>
          </Tab>
        ))}
        {createMode && (
          <Tab size="md" intent="active" className="border-none">
            <Tab.Avatar size="sm">
              <Tab.Avatar.Content
                size="sm"
                label="Add child"
                source={require("@/assets/images/child-avatar.png")}
                labelSize="sm"
              />
            </Tab.Avatar>
            <Tab.Text size="md">Child {children.length + 1}</Tab.Text>
          </Tab>
        )}
      </ScrollView>
      <Button
        size="sm"
        intent="primary"
        borderLess
        icon
        onPress={() => {
          setCreateMode(true);
          scrollViewRef.current?.scrollToEnd();
        }}
      >
        <Button.Icon as={PlusIcon} intent="primary" />
        {!createMode && (
          <Button.Text intent="primary" size="sm">
            Add child
          </Button.Text>
        )}
      </Button>
    </View>
  );
}

export default ChildrenSelectionList;
